import { render, staticRenderFns } from "./SavedCards.vue?vue&type=template&id=32618732&scoped=true&"
import script from "./SavedCards.vue?vue&type=script&lang=js&"
export * from "./SavedCards.vue?vue&type=script&lang=js&"
import style0 from "./SavedCards.vue?vue&type=style&index=0&id=32618732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32618732",
  null
  
)

export default component.exports